module.exports = {
  followUs: 'FOLLOW US',
  product: {
    title: 'PRODUCT',
    overview: 'Overview',
    network: 'ABT Network',
    node: 'ABT Node',
    wallet: 'ABT Wallet',
    blocklets: 'Blocklets',
    sdk: 'Forge SDK',
    ocap: 'OCAP'
  },
  learn: {
    title: 'LEARN MORE',
    community: 'Community',
    workshop: 'DApps Workshop',
    portal: 'Developer Portal',
    documentation: 'Documentation',
    blog: 'Engineering Blog',
    learning: 'Learning',
    solutions: 'Solutions'
  },
  aboutUs: {
    title: 'ABOUT US',
    team: 'Team',
    jobs: 'Jobs',
    leader: 'LeaderShip',
    partners: 'Partners',
    token: 'ABT Token',
    news: 'News & Events'
  },
  contactUs: {
    title: 'CONTACT US',
    support: 'Support',
    forPar: 'For Partners'
  },
  bottom: {
    ts: 'Terms of Service',
    privacy: 'Privacy',
    serviceLevel: 'Service Level',
    siteMap: 'Site Map',
    login: 'Log In'
  }
};